import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'installment-integration-tables-real-estate-developments',
  storeModule.createStoreModule('installment-integration-tables-real-estate-developments')
)
